import Nullstack from 'nullstack';
export default function IconChartInfographic({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-chart-infographic",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7",
    cy: "7",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M7 3v4h4"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "17",
    x2: "9",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "14",
    x2: "17",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "13",
    x2: "13",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "21",
    y1: "12",
    x2: "21",
    y2: "21"
  }), " ");
}